import { XIColors } from '@inmoment/the-kitchen';
import styled from 'styled-components';

export const FAQDropdownWrapper = styled.div`
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  margin: auto;
`;

interface QuestionWrapperStyles {
  isOpen: boolean;
}
export const QuestionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
  background: ${(props: QuestionWrapperStyles) => (props.isOpen ? XIColors.orca.primary : 'transparent')};
  &:hover {
    background: ${(props: QuestionWrapperStyles) => (props.isOpen ? XIColors.orca.primary : XIColors.orca.light[90])};
    color: ${(props: QuestionWrapperStyles) => (props.isOpen ? XIColors.orca.primary : 'black')};
  }
`;
